export default {
  DEV: 'dev',
  STAGE: 'stage',
  PRODUCTION: 'production'
}
